export default "/assets/images/pc-carbon.webp?83a783988d0833034e56c7d08f3f2865";